import React from 'react';
import {
  CircularProgress as MuiCircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Zoom,
  DialogContentText,
  DialogTitle,
  IconButton,
  Button,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import styles from '../app.module.css';

function CardExp({ handleClose, title, contentText, buttonText }) {
  return (
    <Dialog
      PaperProps={{
        style: {
          width: '765px',
          maxWidth: '100%', // optional responsiveness
          borderRadius: '54px',
        },
      }}
      // onClick={closeDialog}
      open
      TransitionComponent={Zoom}
    >
      <DialogTitle className={styles.dialogTitle}>
        <span>{title}</span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText className={styles.dialogContent}>
{contentText}
        </DialogContentText>
      </DialogContent>
      <Button
        className={styles.dialogButton}
        onClick={handleClose}
      >
{buttonText}
      </Button>
    </Dialog>
  );
}

export default CardExp;
